import { SearchEndpoints, SearchRoutes } from "@/types";

export enum VignetteVisibility {
  WEB_USER_ONLY, // visible to web users only (not ip users)
  MEMBER_ONLY, // visible to Vignette members, or NJ members with Vignette access
  // NJ_MEMBER_ONLY, // visible to NJ member without Vignette access
  PUBLIC_ONLY, // visible to anonymous users
  ALL, // visible to all users
}

/**
 * This interface is used to define custom metadata for routes. Make sure to add to this before adding to routes.
 */
export interface CustomRouteMeta {
  /**
   * This determines what type of user can view this page.
   */
  visibility: VignetteVisibility;
  /**
   * This is currently unused. Future work will probably remove this.
   * @deprecated
   */
  label: string;
  /**
   * This is currently unused. Future work will probably remove this.
   * @deprecated
   */
  icon: string;
  /**
   * This is currently unused. Future work will probably remove this.
   * @deprecated
   */
  excludedFromNavBar: boolean;
  /**
   * This is currently unused. Future work will probably remove this.
   * @deprecated
   */
  sortOrder: number;
  /**
   * This is currently used solely on searchbar.vue to determine that type of transition between searches
   */
  transition?: string;
  /**
   * This is used on KeywordSearch.vue to determine what route to push to when a user submits a search on a non-search
   * page.
   */
  searchRoute?: SearchRoutes;
  /**
   * This is used on search pages to determine what endpoint to use to search.
   */
  searchEndpoint?: SearchEndpoints;
  /**
   * This is used on KeywordSearch.vue to determine what text to display as the hint for the input field.
   */
  searchHint?: string;
  /**
   * This is used on KeywordSearch.vue to determine what text to display as the label for the input field.
   */
  searchLabel?: string;
}
